export function isNumeric(value: any): boolean {
  return typeof value === 'number' && !isNaN(value);
}
